import { useReduxState } from 'hooks';
import { DropdownSelectable } from 'components/common/dropdown';

export type CalendarEventParticipantsView = 'attributes' | 'default';

interface Props {
  onChange: (view: CalendarEventParticipantsView) => void;
  view: CalendarEventParticipantsView;
}

const CalendarEventParticipantsViewSelector = ({ onChange, view }: Props) => {
  const { messages } = useReduxState();

  return (
    <DropdownSelectable
      category="lighter"
      defaultText={`${messages.commonSelect}...`}
      defaultValue={view}
      dropdownTextMinWidth="120px"
      onChange={onChange}
      options={[
        {
          text: messages.commonDefault,
          value: 'default'
        },
        {
          text: messages.eventCalendarParticipantData,
          value: 'attributes'
        }
      ]}
      selectedValueBefore={`${messages.commonView}:`}
      showSelectedText={true}
      size="header"
      titleMaxWidth={200}
      value={view}
    />
  );
};

export default CalendarEventParticipantsViewSelector;
